import React from 'react';
import { FiTrendingUp, FiTrendingDown, FiMinus } from 'react-icons/fi';

export default function AnalyticsWidget({
  title,
  value,
  previousValue,
  suffix = '',
  prefix = '',
  trend,
  color = '#3B82F6',
  backgroundColor = '#F8FAFC',
  icon: Icon,
  subtitle,
  onClick,
  loading = false
}) {
  // Calculate trend if not provided
  const calculatedTrend = trend || (previousValue !== undefined ? 
    ((value - previousValue) / previousValue * 100).toFixed(1) : null);

  const trendDirection = calculatedTrend > 0 ? 'up' : calculatedTrend < 0 ? 'down' : 'neutral';
  const trendColor = trendDirection === 'up' ? '#10B981' : 
                    trendDirection === 'down' ? '#EF4444' : '#6B7280';

  const TrendIcon = trendDirection === 'up' ? FiTrendingUp : 
                   trendDirection === 'down' ? FiTrendingDown : FiMinus;

  if (loading) {
    return (
      <div className="analytics-widget loading" style={{
        background: backgroundColor,
        border: `1px solid ${color}20`,
        borderRadius: '12px',
        padding: '1.5rem',
        minHeight: '120px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  return (
    <div 
      className="analytics-widget" 
      style={{
        background: backgroundColor,
        border: `1px solid ${color}20`,
        borderRadius: '12px',
        padding: '1.5rem',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
      }}
      onClick={onClick}
      onMouseOver={(e) => {
        if (onClick) {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
        }
      }}
      onMouseOut={(e) => {
        if (onClick) {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.02)';
        }
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={{ flex: 1 }}>
          <h4 style={{ 
            margin: '0 0 0.5rem 0', 
            color: '#374151', 
            fontSize: '0.875rem', 
            fontWeight: '500' 
          }}>
            {title}
          </h4>
          
          <div style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold', 
            color: color,
            lineHeight: '1.2',
            marginBottom: '0.5rem'
          }}>
            {prefix}{typeof value === 'number' ? value.toLocaleString() : value}{suffix}
          </div>

          {subtitle && (
            <p style={{ 
              margin: '0 0 0.5rem 0', 
              color: '#6B7280', 
              fontSize: '0.75rem' 
            }}>
              {subtitle}
            </p>
          )}

          {calculatedTrend !== null && (
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.25rem',
              fontSize: '0.75rem',
              color: trendColor
            }}>
              <TrendIcon size={12} />
              <span>{Math.abs(calculatedTrend)}%</span>
              <span style={{ color: '#6B7280' }}>vs previous</span>
            </div>
          )}
        </div>

        {Icon && (
          <div style={{
            padding: '0.75rem',
            borderRadius: '8px',
            backgroundColor: `${color}15`,
            color: color
          }}>
            <Icon size={24} />
          </div>
        )}
      </div>
    </div>
  );
}